export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Represents `true` or `false` values. */
  BooleanWithStrings: { input: unknown; output: unknown; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: string; output: string; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: string; output: string; }
};

/** Autogenerated input type of AddDraftGroupCriteria */
export type AddDraftGroupCriteriaInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  criteria: CriteriasMutationInput;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AddDraftGroupCriteria. */
export type AddDraftGroupCriteriaPayload = {
  __typename?: 'AddDraftGroupCriteriaPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  draftGroup?: Maybe<DraftGroup>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AddDraftGroupUser */
export type AddDraftGroupUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  user: DraftUserInput;
};

/** Autogenerated return type of AddDraftGroupUser. */
export type AddDraftGroupUserPayload = {
  __typename?: 'AddDraftGroupUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
  user?: Maybe<DraftUser>;
};

/** Autogenerated input type of AddGroupLeaders */
export type AddGroupLeadersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  users: Array<DraftUserInput>;
};

/** Autogenerated return type of AddGroupLeaders. */
export type AddGroupLeadersPayload = {
  __typename?: 'AddGroupLeadersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
  users?: Maybe<Array<User>>;
};

/** Autogenerated input type of AddShifts */
export type AddShiftsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  shifts: Array<ShiftInput>;
};

/** Autogenerated return type of AddShifts. */
export type AddShiftsPayload = {
  __typename?: 'AddShiftsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  roster?: Maybe<Roster>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AddSupporterToGroup */
export type AddSupporterToGroupInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  engagementLevelId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  groupId: Scalars['ID']['input'];
  lastName: Scalars['String']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  sendAutoresponse?: InputMaybe<Scalars['Boolean']['input']>;
  sendNotification?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AddSupporterToGroup. */
export type AddSupporterToGroupPayload = {
  __typename?: 'AddSupporterToGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
  supporter?: Maybe<Supporter>;
};

/** Autogenerated input type of ArchiveCallingSession */
export type ArchiveCallingSessionInput = {
  callingSessionId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ArchiveCallingSession. */
export type ArchiveCallingSessionPayload = {
  __typename?: 'ArchiveCallingSessionPayload';
  callingSession?: Maybe<CallingSession>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ArchiveEvent */
export type ArchiveEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveEvent. */
export type ArchiveEventPayload = {
  __typename?: 'ArchiveEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  event?: Maybe<Event>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ArchiveGroup */
export type ArchiveGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveGroup. */
export type ArchiveGroupPayload = {
  __typename?: 'ArchiveGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  group?: Maybe<Group>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ArchiveShifts */
export type ArchiveShiftsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ArchiveShifts. */
export type ArchiveShiftsPayload = {
  __typename?: 'ArchiveShiftsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AssignShiftSlot */
export type AssignShiftSlotInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  supporterId: Scalars['ID']['input'];
};

/** Autogenerated return type of AssignShiftSlot. */
export type AssignShiftSlotPayload = {
  __typename?: 'AssignShiftSlotPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  shiftSlot?: Maybe<ShiftSlot>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** A volunteer referenced in a shift's change breakdown (added or removed). */
export type AssigneeRef = {
  __typename?: 'AssigneeRef';
  fullName?: Maybe<Scalars['String']['output']>;
  personId: Scalars['ID']['output'];
};

/** An object with an ID. */
export type BaseNode = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

/** Who a blast reaches */
export type BlastAudience = {
  __typename?: 'BlastAudience';
  /** all_members or all_rsvps */
  kind: Scalars['String']['output'];
  /** attendees, non_attendees or all_rsvps. Only offered once the event is past. */
  rsvpType?: Maybe<Scalars['String']['output']>;
};

/** A call list belonging to an action group */
export type CallList = BaseNode & {
  __typename?: 'CallList';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A calling cycle within a calling session */
export type CallingCycle = BaseNode & {
  __typename?: 'CallingCycle';
  callsAttemptedCount: Scalars['Int']['output'];
  completed: Scalars['Boolean']['output'];
  completedSupportersCount: Scalars['Int']['output'];
  cycleNumber: Scalars['Int']['output'];
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  finishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  successfulCount: Scalars['Int']['output'];
  unsuccessfulCount: Scalars['Int']['output'];
};

/** A calling session belonging to a user */
export type CallingSession = BaseNode & {
  __typename?: 'CallingSession';
  actionGroupId: Scalars['ID']['output'];
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  availableSupportersThisCycleCount: Scalars['Int']['output'];
  callInProgressAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  callList: CallList;
  completedCycles: Array<CallingCycle>;
  completedSupportersCount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentCycle?: Maybe<CallingCycle>;
  id: Scalars['ID']['output'];
  lastAttemptedSessionSupporter?: Maybe<CallingSessionSupporter>;
  lastAttemptedSupporter?: Maybe<Supporter>;
  name?: Maybe<Scalars['String']['output']>;
  nextAvailableSessionSupporterToCall?: Maybe<CallingSessionSupporter>;
  nextSessionSupporterToCall?: Maybe<CallingSessionSupporter>;
  nextSupporterToCall?: Maybe<Supporter>;
  paused: Scalars['Boolean']['output'];
  sessionProgress?: Maybe<ProgressBar>;
  sessionSupporters: Array<CallingSessionSupporter>;
  status: Scalars['String']['output'];
  successfulContactsCount: Scalars['Int']['output'];
  totalCallsAttemptedCount: Scalars['Int']['output'];
  totalSupportersCount: Scalars['Int']['output'];
  unsuccessfulContactsCount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
};

/** The connection type for CallingSession. */
export type CallingSessionConnection = {
  __typename?: 'CallingSessionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CallingSessionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CallingSession>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type CallingSessionEdge = {
  __typename?: 'CallingSessionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CallingSession>;
};

/** A skip record for a calling session supporter */
export type CallingSessionSkip = BaseNode & {
  __typename?: 'CallingSessionSkip';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  skipType: CallingSessionSkipTypeEnum;
  skippedById?: Maybe<Scalars['ID']['output']>;
};

/** The type of skip applied to a supporter in a calling session */
export enum CallingSessionSkipTypeEnum {
  /** Skipped for a specific duration */
  Duration = 'duration',
  /** Permanently removed from this session */
  Permanent = 'permanent',
  /** System-skipped due to unavailability */
  SystemUnavailable = 'system_unavailable',
  /** Skipped for the current cycle */
  ThisCycle = 'this_cycle',
  /** Skipped for the rest of today */
  Today = 'today',
  /** Skipped until a specific date */
  UntilDate = 'until_date'
}

/** A calling session supporter belonging to a calling session */
export type CallingSessionSupporter = BaseNode & {
  __typename?: 'CallingSessionSupporter';
  actionGroupId: Scalars['ID']['output'];
  activeSkip?: Maybe<CallingSessionSkip>;
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  callingSession: CallingSession;
  callingSessionId: Scalars['ID']['output'];
  completed?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  lastCallAttemptAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  nextCallingSessionSupporter?: Maybe<CallingSessionSupporter>;
  outcome?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  previousCallingSessionSupporter?: Maybe<CallingSessionSupporter>;
  status: Scalars['String']['output'];
  supporter?: Maybe<Supporter>;
  supporterId?: Maybe<Scalars['ID']['output']>;
  unavailableReason?: Maybe<Scalars['String']['output']>;
  unavailableUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for CallingSessionSupporter. */
export type CallingSessionSupporterConnection = {
  __typename?: 'CallingSessionSupporterConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CallingSessionSupporterEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CallingSessionSupporter>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type CallingSessionSupporterEdge = {
  __typename?: 'CallingSessionSupporterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CallingSessionSupporter>;
};

/** An interaction with a supporter */
export type Contact = BaseNode & {
  __typename?: 'Contact';
  actionGroupId: Scalars['ID']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  externalCreatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  method: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  personId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  /** Find child User. */
  user?: Maybe<User>;
  viaActionCentre?: Maybe<Scalars['Boolean']['output']>;
};

/** The connection type for Contact. */
export type ContactConnection = {
  __typename?: 'ContactConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ContactEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Contact>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type ContactEdge = {
  __typename?: 'ContactEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Contact>;
};

/** Autogenerated input type of CreateDraftGroup */
export type CreateDraftGroupInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasPhysicalAddress?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notifyAllAdmins?: InputMaybe<Scalars['Boolean']['input']>;
  pointPeople?: InputMaybe<Array<Scalars['ID']['input']>>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  publicPublish?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  venueName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateDraftGroup. */
export type CreateDraftGroupPayload = {
  __typename?: 'CreateDraftGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  draftGroup?: Maybe<DraftGroup>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateGroup */
export type CreateGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateGroup. */
export type CreateGroupPayload = {
  __typename?: 'CreateGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  group?: Maybe<Group>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateSupporterNote */
export type CreateSupporterNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  groupId: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateSupporterNote. */
export type CreateSupporterNotePayload = {
  __typename?: 'CreateSupporterNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
  supporterNote?: Maybe<SupporterNote>;
};

export type CriteriaInput = {
  combinator: Scalars['String']['input'];
  rules?: InputMaybe<CriteriaRulesInput>;
};

export type CriteriaMutationRuleInput = {
  enabled: Scalars['Boolean']['input'];
  predicate?: InputMaybe<Scalars['String']['input']>;
  values?: Array<Scalars['String']['input']>;
};

export type CriteriaMutationRulesInput = {
  exclusionTags?: InputMaybe<CriteriaMutationRuleInput>;
  tags?: InputMaybe<CriteriaMutationRuleInput>;
  zip?: InputMaybe<CriteriaMutationRuleInput>;
};

export type CriteriaRuleInput = {
  enabled: Scalars['Boolean']['input'];
  predicate?: InputMaybe<Scalars['String']['input']>;
  values?: Array<Scalars['String']['input']>;
};

export type CriteriaRulesInput = {
  exclusionTags?: InputMaybe<CriteriaRuleInput>;
  tags?: InputMaybe<CriteriaRuleInput>;
  zip?: InputMaybe<CriteriaRuleInput>;
};

export type CriteriasMutationInput = {
  combinator: Scalars['String']['input'];
  rules?: InputMaybe<CriteriaMutationRulesInput>;
};

export type DraftCriteria = {
  __typename?: 'DraftCriteria';
  combinator: Scalars['String']['output'];
  rules: Array<DraftCriteriaRule>;
};

export type DraftCriteriaRule = {
  __typename?: 'DraftCriteriaRule';
  predicate: Scalars['String']['output'];
  property: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

/** A draft of a group of supporters */
export type DraftGroup = BaseNode & {
  __typename?: 'DraftGroup';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  criteria?: Maybe<DraftCriteria>;
  description: Scalars['String']['output'];
  hasPhysicalAddress?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  notifyAllAdmins?: Maybe<Scalars['Boolean']['output']>;
  /** Query related PointPeople with filters. */
  pointPeople: UserConnection;
  postcode?: Maybe<Scalars['String']['output']>;
  publicDescription?: Maybe<Scalars['String']['output']>;
  publicPublish?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  users: Array<DraftUser>;
  venueName?: Maybe<Scalars['String']['output']>;
};


/** A draft of a group of supporters */
export type DraftGroupPointPeopleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  emailEnd?: InputMaybe<Scalars['String']['input']>;
  emailEq?: InputMaybe<Scalars['String']['input']>;
  emailICont?: InputMaybe<Scalars['String']['input']>;
  emailIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  emailIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailNotEq?: InputMaybe<Scalars['String']['input']>;
  emailNotICont?: InputMaybe<Scalars['String']['input']>;
  emailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailStart?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  firstNameEnd?: InputMaybe<Scalars['String']['input']>;
  firstNameEq?: InputMaybe<Scalars['String']['input']>;
  firstNameICont?: InputMaybe<Scalars['String']['input']>;
  firstNameIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameNotEq?: InputMaybe<Scalars['String']['input']>;
  firstNameNotICont?: InputMaybe<Scalars['String']['input']>;
  firstNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameStart?: InputMaybe<Scalars['String']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastNameEnd?: InputMaybe<Scalars['String']['input']>;
  lastNameEq?: InputMaybe<Scalars['String']['input']>;
  lastNameICont?: InputMaybe<Scalars['String']['input']>;
  lastNameIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameNotEq?: InputMaybe<Scalars['String']['input']>;
  lastNameNotICont?: InputMaybe<Scalars['String']['input']>;
  lastNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameStart?: InputMaybe<Scalars['String']['input']>;
  mobileEnd?: InputMaybe<Scalars['String']['input']>;
  mobileEq?: InputMaybe<Scalars['String']['input']>;
  mobileICont?: InputMaybe<Scalars['String']['input']>;
  mobileIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileNotEq?: InputMaybe<Scalars['String']['input']>;
  mobileNotICont?: InputMaybe<Scalars['String']['input']>;
  mobileNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileStart?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for DraftGroup. */
export type DraftGroupConnection = {
  __typename?: 'DraftGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DraftGroupEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DraftGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type DraftGroupEdge = {
  __typename?: 'DraftGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DraftGroup>;
};

export type DraftUser = {
  __typename?: 'DraftUser';
  email: Scalars['String']['output'];
};

export type DraftUserInput = {
  email: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

/** Autogenerated input type of EditShift */
export type EditShiftInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  shift: ShiftInput;
};

/** Autogenerated return type of EditShift. */
export type EditShiftPayload = {
  __typename?: 'EditShiftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  shift?: Maybe<Shift>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** An email blast */
export type EmailBlast = BaseNode & {
  __typename?: 'EmailBlast';
  actionGroup?: Maybe<Group>;
  audience: BlastAudience;
  /** Used to derive per-row permissions on the client */
  authorId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  recipientCount: Scalars['Int']['output'];
  /** When an upcoming send goes out. Null unless the blast is scheduled or approved. */
  scheduledFor?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the blast actually went out. Null unless it is sent. */
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: Scalars['String']['output'];
  /** The email's subject, or the SMS's message */
  title?: Maybe<Scalars['String']['output']>;
};

/** The connection type for EmailBlast. */
export type EmailBlastConnection = {
  __typename?: 'EmailBlastConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EmailBlastEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EmailBlast>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type EmailBlastEdge = {
  __typename?: 'EmailBlastEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EmailBlast>;
};

/** An email thread */
export type EmailThread = BaseNode & {
  __typename?: 'EmailThread';
  id: Scalars['ID']['output'];
  isResponded: Scalars['Boolean']['output'];
  personId?: Maybe<Scalars['ID']['output']>;
};

/** The connection type for EmailThread. */
export type EmailThreadConnection = {
  __typename?: 'EmailThreadConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EmailThreadEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EmailThread>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type EmailThreadEdge = {
  __typename?: 'EmailThreadEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EmailThread>;
};

/** An engagement level for a supporter */
export type EngagementLevel = {
  __typename?: 'EngagementLevel';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for EngagementLevel. */
export type EngagementLevelConnection = {
  __typename?: 'EngagementLevelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EngagementLevelEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EngagementLevel>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type EngagementLevelEdge = {
  __typename?: 'EngagementLevelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EngagementLevel>;
};

/** An event */
export type Event = BaseNode & {
  __typename?: 'Event';
  archived: Scalars['Boolean']['output'];
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  capacity: Scalars['Int']['output'];
  endTime: Scalars['ISO8601DateTime']['output'];
  fullVenueAddress?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Group>;
  /** Whether the supporter has an active RSVP to this event */
  hasRsvpFromSupporter: Scalars['Boolean']['output'];
  ianaTimeZone?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isApproved?: Maybe<Scalars['Boolean']['output']>;
  isFull: Scalars['Boolean']['output'];
  /** Whether the event has already happened */
  isPast: Scalars['Boolean']['output'];
  /** Published shifts, ordered by start time */
  liveShifts: Array<Shift>;
  name: Scalars['String']['output'];
  /** Find child Roster. */
  roster?: Maybe<Roster>;
  spanningDates?: Maybe<Array<Scalars['ISO8601DateTime']['output']>>;
  startTime: Scalars['ISO8601DateTime']['output'];
};


/** An event */
export type EventHasRsvpFromSupporterArgs = {
  supporterId: Scalars['ID']['input'];
};

/** The connection type for Event. */
export type EventConnection = {
  __typename?: 'EventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EventEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Event>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type EventEdge = {
  __typename?: 'EventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Event>;
};

/** What to do with one supporter's RSVP on one event */
export enum EventRsvpAction {
  /** Cancel the supporter's active RSVP, if they have one. */
  Cancel = 'CANCEL',
  /** Register the supporter for the event. */
  Register = 'REGISTER'
}

/** One change to a supporter's RSVP on one event */
export type EventRsvpInput = {
  /** Whether to register or cancel the RSVP */
  action: EventRsvpAction;
  /** The event whose RSVP is changing */
  eventId: Scalars['ID']['input'];
  /** The complete desired set of self-select shifts; omit to leave shifts unchanged */
  shiftIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated input type of ExportGroupSupporters */
export type ExportGroupSupportersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exportFormat: Scalars['String']['input'];
  filters?: InputMaybe<Array<SupporterSearchFiltersInputType>>;
  groupId: Scalars['ID']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ExportGroupSupporters. */
export type ExportGroupSupportersPayload = {
  __typename?: 'ExportGroupSupportersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ExportRoster */
export type ExportRosterInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  format: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ExportRoster. */
export type ExportRosterPayload = {
  __typename?: 'ExportRosterPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ExportSupportersCsv */
export type ExportSupportersCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ExportSupportersCsv. */
export type ExportSupportersCsvPayload = {
  __typename?: 'ExportSupportersCsvPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** A federal district */
export type FederalDistrict = {
  __typename?: 'FederalDistrict';
  /** The federal district value */
  id: Scalars['String']['output'];
  /** The federal district name */
  name: Scalars['String']['output'];
};

/** The connection type for FederalDistrict. */
export type FederalDistrictConnection = {
  __typename?: 'FederalDistrictConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FederalDistrictEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FederalDistrict>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type FederalDistrictEdge = {
  __typename?: 'FederalDistrictEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FederalDistrict>;
};

/** One edited field in a shift's change breakdown, as a before and after value. */
export type FieldChange = {
  __typename?: 'FieldChange';
  from?: Maybe<Scalars['String']['output']>;
  key: FieldChangeKey;
  to?: Maybe<Scalars['String']['output']>;
};

/** Which field of a shift changed since it was last published. */
export enum FieldChangeKey {
  /** Self-select access changed. */
  AllowSelfSelect = 'ALLOW_SELF_SELECT',
  /** The shift was moved to another day. */
  Date = 'DATE',
  /** The end time changed. */
  EndTime = 'END_TIME',
  /** The role name changed. */
  RoleName = 'ROLE_NAME',
  /** The start time changed. */
  StartTime = 'START_TIME',
  /** The number of volunteers needed changed. */
  VolunteersRequired = 'VOLUNTEERS_REQUIRED'
}

/** A group of supporters */
export type Group = BaseNode & {
  __typename?: 'Group';
  /** Query related Captains with filters. */
  captains: UserConnection;
  city?: Maybe<Scalars['String']['output']>;
  /** Query related Contacts with filters. */
  contacts: ContactConnection;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Find child GroupCriteria. */
  criteria: GroupCriteria;
  description?: Maybe<Scalars['String']['output']>;
  /** Query related EmailThreads with filters. */
  emailThreads: EmailThreadConnection;
  /** Query related Events with filters. */
  events: EventConnection;
  hasPhysicalAddress: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Query related Leaders with filters. */
  leaders: UserConnection;
  longitude?: Maybe<Scalars['Float']['output']>;
  mailerSender?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notifyAllAdmins?: Maybe<Scalars['Boolean']['output']>;
  /** Query related PointPeople with filters. */
  pointPeople: UserConnection;
  postcode?: Maybe<Scalars['String']['output']>;
  publicDescription: Scalars['String']['output'];
  publicPublish: Scalars['Boolean']['output'];
  publicUrl?: Maybe<Scalars['String']['output']>;
  /** Query related SmsThreads with filters. */
  smsThreads: SmsThreadConnection;
  state?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  streetAddress?: Maybe<Scalars['String']['output']>;
  /** Query related Supporters with filters. */
  supporters: GroupSupporterConnection;
  venueName?: Maybe<Scalars['String']['output']>;
};


/** A group of supporters */
export type GroupCaptainsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  emailEnd?: InputMaybe<Scalars['String']['input']>;
  emailEq?: InputMaybe<Scalars['String']['input']>;
  emailICont?: InputMaybe<Scalars['String']['input']>;
  emailIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  emailIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailNotEq?: InputMaybe<Scalars['String']['input']>;
  emailNotICont?: InputMaybe<Scalars['String']['input']>;
  emailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailStart?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  firstNameEnd?: InputMaybe<Scalars['String']['input']>;
  firstNameEq?: InputMaybe<Scalars['String']['input']>;
  firstNameICont?: InputMaybe<Scalars['String']['input']>;
  firstNameIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameNotEq?: InputMaybe<Scalars['String']['input']>;
  firstNameNotICont?: InputMaybe<Scalars['String']['input']>;
  firstNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameStart?: InputMaybe<Scalars['String']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastNameEnd?: InputMaybe<Scalars['String']['input']>;
  lastNameEq?: InputMaybe<Scalars['String']['input']>;
  lastNameICont?: InputMaybe<Scalars['String']['input']>;
  lastNameIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameNotEq?: InputMaybe<Scalars['String']['input']>;
  lastNameNotICont?: InputMaybe<Scalars['String']['input']>;
  lastNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameStart?: InputMaybe<Scalars['String']['input']>;
  mobileEnd?: InputMaybe<Scalars['String']['input']>;
  mobileEq?: InputMaybe<Scalars['String']['input']>;
  mobileICont?: InputMaybe<Scalars['String']['input']>;
  mobileIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileNotEq?: InputMaybe<Scalars['String']['input']>;
  mobileNotICont?: InputMaybe<Scalars['String']['input']>;
  mobileNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileStart?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


/** A group of supporters */
export type GroupContactsArgs = {
  actionGroupIdEq?: InputMaybe<Scalars['ID']['input']>;
  actionGroupIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  actionGroupIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  actionGroupIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  actionGroupIdNotNull?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  externalCreatedAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  externalCreatedAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  externalCreatedAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  externalCreatedAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  externalCreatedAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  externalCreatedAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  methodEnd?: InputMaybe<Scalars['String']['input']>;
  methodEq?: InputMaybe<Scalars['String']['input']>;
  methodICont?: InputMaybe<Scalars['String']['input']>;
  methodIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  methodIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  methodIn?: InputMaybe<Array<Scalars['String']['input']>>;
  methodNotEq?: InputMaybe<Scalars['String']['input']>;
  methodNotICont?: InputMaybe<Scalars['String']['input']>;
  methodNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  methodStart?: InputMaybe<Scalars['String']['input']>;
  noteEnd?: InputMaybe<Scalars['String']['input']>;
  noteEq?: InputMaybe<Scalars['String']['input']>;
  noteICont?: InputMaybe<Scalars['String']['input']>;
  noteIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  noteIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  noteIn?: InputMaybe<Array<Scalars['String']['input']>>;
  noteNotEq?: InputMaybe<Scalars['String']['input']>;
  noteNotICont?: InputMaybe<Scalars['String']['input']>;
  noteNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  noteStart?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  personIdEq?: InputMaybe<Scalars['ID']['input']>;
  personIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  personIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  personIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  personIdNotNull?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  statusEnd?: InputMaybe<Scalars['String']['input']>;
  statusEq?: InputMaybe<Scalars['String']['input']>;
  statusICont?: InputMaybe<Scalars['String']['input']>;
  statusIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  statusIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  statusIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statusNotEq?: InputMaybe<Scalars['String']['input']>;
  statusNotICont?: InputMaybe<Scalars['String']['input']>;
  statusNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statusStart?: InputMaybe<Scalars['String']['input']>;
  userIdEq?: InputMaybe<Scalars['ID']['input']>;
  userIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  userIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIdNotNull?: InputMaybe<Scalars['ID']['input']>;
  viaActionCentreEq?: InputMaybe<Scalars['Boolean']['input']>;
  viaActionCentreNotEq?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A group of supporters */
export type GroupEmailThreadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  isRespondedEq?: InputMaybe<Scalars['Boolean']['input']>;
  isRespondedNotEq?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  matched?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  personIdEq?: InputMaybe<Scalars['ID']['input']>;
  personIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  personIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  personIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  personIdNotNull?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


/** A group of supporters */
export type GroupEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  archivedAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  archivedAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  archivedAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  archivedAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  archivedAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  capacityEq?: InputMaybe<Scalars['Int']['input']>;
  capacityGt?: InputMaybe<Scalars['Int']['input']>;
  capacityGteq?: InputMaybe<Scalars['Int']['input']>;
  capacityLt?: InputMaybe<Scalars['Int']['input']>;
  capacityLteq?: InputMaybe<Scalars['Int']['input']>;
  capacityNotEq?: InputMaybe<Scalars['Int']['input']>;
  capacityNotNull?: InputMaybe<Scalars['Int']['input']>;
  endTimeEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endTimeGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endTimeGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endTimeLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endTimeLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endTimeNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  isApprovedEq?: InputMaybe<Scalars['Boolean']['input']>;
  isApprovedNotEq?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameEnd?: InputMaybe<Scalars['String']['input']>;
  nameEq?: InputMaybe<Scalars['String']['input']>;
  nameICont?: InputMaybe<Scalars['String']['input']>;
  nameIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNotEq?: InputMaybe<Scalars['String']['input']>;
  nameNotICont?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameStart?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  startTimeEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  startTimeGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  startTimeGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  startTimeLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  startTimeLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  startTimeNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


/** A group of supporters */
export type GroupLeadersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  emailEnd?: InputMaybe<Scalars['String']['input']>;
  emailEq?: InputMaybe<Scalars['String']['input']>;
  emailICont?: InputMaybe<Scalars['String']['input']>;
  emailIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  emailIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailNotEq?: InputMaybe<Scalars['String']['input']>;
  emailNotICont?: InputMaybe<Scalars['String']['input']>;
  emailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailStart?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  firstNameEnd?: InputMaybe<Scalars['String']['input']>;
  firstNameEq?: InputMaybe<Scalars['String']['input']>;
  firstNameICont?: InputMaybe<Scalars['String']['input']>;
  firstNameIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameNotEq?: InputMaybe<Scalars['String']['input']>;
  firstNameNotICont?: InputMaybe<Scalars['String']['input']>;
  firstNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameStart?: InputMaybe<Scalars['String']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastNameEnd?: InputMaybe<Scalars['String']['input']>;
  lastNameEq?: InputMaybe<Scalars['String']['input']>;
  lastNameICont?: InputMaybe<Scalars['String']['input']>;
  lastNameIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameNotEq?: InputMaybe<Scalars['String']['input']>;
  lastNameNotICont?: InputMaybe<Scalars['String']['input']>;
  lastNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameStart?: InputMaybe<Scalars['String']['input']>;
  mobileEnd?: InputMaybe<Scalars['String']['input']>;
  mobileEq?: InputMaybe<Scalars['String']['input']>;
  mobileICont?: InputMaybe<Scalars['String']['input']>;
  mobileIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileNotEq?: InputMaybe<Scalars['String']['input']>;
  mobileNotICont?: InputMaybe<Scalars['String']['input']>;
  mobileNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileStart?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


/** A group of supporters */
export type GroupPointPeopleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  emailEnd?: InputMaybe<Scalars['String']['input']>;
  emailEq?: InputMaybe<Scalars['String']['input']>;
  emailICont?: InputMaybe<Scalars['String']['input']>;
  emailIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  emailIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailNotEq?: InputMaybe<Scalars['String']['input']>;
  emailNotICont?: InputMaybe<Scalars['String']['input']>;
  emailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailStart?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  firstNameEnd?: InputMaybe<Scalars['String']['input']>;
  firstNameEq?: InputMaybe<Scalars['String']['input']>;
  firstNameICont?: InputMaybe<Scalars['String']['input']>;
  firstNameIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameNotEq?: InputMaybe<Scalars['String']['input']>;
  firstNameNotICont?: InputMaybe<Scalars['String']['input']>;
  firstNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameStart?: InputMaybe<Scalars['String']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastNameEnd?: InputMaybe<Scalars['String']['input']>;
  lastNameEq?: InputMaybe<Scalars['String']['input']>;
  lastNameICont?: InputMaybe<Scalars['String']['input']>;
  lastNameIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameNotEq?: InputMaybe<Scalars['String']['input']>;
  lastNameNotICont?: InputMaybe<Scalars['String']['input']>;
  lastNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameStart?: InputMaybe<Scalars['String']['input']>;
  mobileEnd?: InputMaybe<Scalars['String']['input']>;
  mobileEq?: InputMaybe<Scalars['String']['input']>;
  mobileICont?: InputMaybe<Scalars['String']['input']>;
  mobileIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileNotEq?: InputMaybe<Scalars['String']['input']>;
  mobileNotICont?: InputMaybe<Scalars['String']['input']>;
  mobileNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileStart?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


/** A group of supporters */
export type GroupSmsThreadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  isRespondedEq?: InputMaybe<Scalars['Boolean']['input']>;
  isRespondedNotEq?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  matched?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  personIdEq?: InputMaybe<Scalars['ID']['input']>;
  personIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  personIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  personIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  personIdNotNull?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


/** A group of supporters */
export type GroupSupportersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fullNameICont?: InputMaybe<Scalars['String']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchFilters?: InputMaybe<Array<SupporterSearchFiltersInputType>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for Group. */
export type GroupConnection = {
  __typename?: 'GroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GroupEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Group>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** The rules determining group membership */
export type GroupCriteria = BaseNode & {
  __typename?: 'GroupCriteria';
  actionGroupId: Scalars['ID']['output'];
  combinator: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Query related Rules with filters. */
  rules: GroupCriteriaRuleConnection;
};


/** The rules determining group membership */
export type GroupCriteriaRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  predicateEnd?: InputMaybe<Scalars['String']['input']>;
  predicateEq?: InputMaybe<Scalars['String']['input']>;
  predicateICont?: InputMaybe<Scalars['String']['input']>;
  predicateIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  predicateIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  predicateIn?: InputMaybe<Array<Scalars['String']['input']>>;
  predicateNotEq?: InputMaybe<Scalars['String']['input']>;
  predicateNotICont?: InputMaybe<Scalars['String']['input']>;
  predicateNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  predicateStart?: InputMaybe<Scalars['String']['input']>;
  propertyEnd?: InputMaybe<Scalars['String']['input']>;
  propertyEq?: InputMaybe<Scalars['String']['input']>;
  propertyICont?: InputMaybe<Scalars['String']['input']>;
  propertyIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  propertyIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  propertyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  propertyNotEq?: InputMaybe<Scalars['String']['input']>;
  propertyNotICont?: InputMaybe<Scalars['String']['input']>;
  propertyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  propertyStart?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

/** The rules to match a set of supporters */
export type GroupCriteriaRule = BaseNode & {
  __typename?: 'GroupCriteriaRule';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  predicate: Scalars['String']['output'];
  property: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

/** The connection type for GroupCriteriaRule. */
export type GroupCriteriaRuleConnection = {
  __typename?: 'GroupCriteriaRuleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GroupCriteriaRuleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GroupCriteriaRule>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type GroupCriteriaRuleEdge = {
  __typename?: 'GroupCriteriaRuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GroupCriteriaRule>;
};

/** An edge in a connection. */
export type GroupEdge = {
  __typename?: 'GroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Group>;
};

/** A supporter's membership in a group */
export type GroupMembership = {
  __typename?: 'GroupMembership';
  actionGroupId: Scalars['ID']['output'];
  callable: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  emailable: Scalars['Boolean']['output'];
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  personId: Scalars['ID']['output'];
  textable: Scalars['Boolean']['output'];
};

/** The connection type for GroupMembership. */
export type GroupMembershipConnection = {
  __typename?: 'GroupMembershipConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GroupMembershipEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GroupMembership>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type GroupMembershipEdge = {
  __typename?: 'GroupMembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GroupMembership>;
};

/** The connection type for Supporter. */
export type GroupSupporterConnection = {
  __typename?: 'GroupSupporterConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GroupSupporterEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Supporter>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type GroupSupporterEdge = {
  __typename?: 'GroupSupporterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  membership?: Maybe<GroupMembership>;
  /** The item at the end of the edge. */
  node?: Maybe<Supporter>;
  tagFilters?: Maybe<Array<TagFilter>>;
  unsubscriber?: Maybe<Unsubscriber>;
};

/** Autogenerated input type of InitiateCall */
export type InitiateCallInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['ID']['input'];
  supporterId: Scalars['ID']['input'];
};

/** Autogenerated return type of InitiateCall. */
export type InitiateCallPayload = {
  __typename?: 'InitiateCallPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of InitiateCallingSession */
export type InitiateCallingSessionInput = {
  callingSessionId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of InitiateCallingSession. */
export type InitiateCallingSessionPayload = {
  __typename?: 'InitiateCallingSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of LogContact */
export type LogContactInput = {
  callCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  callListId?: InputMaybe<Scalars['ID']['input']>;
  callListPersonId?: InputMaybe<Scalars['ID']['input']>;
  callingSessionSupporterId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  connected?: InputMaybe<Scalars['Boolean']['input']>;
  contactMethod: Scalars['String']['input'];
  contactStatus: Scalars['String']['input'];
  eventRsvps?: InputMaybe<Array<EventRsvpInput>>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  supporterId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of LogContact. */
export type LogContactPayload = {
  __typename?: 'LogContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addDraftGroupCriteria?: Maybe<AddDraftGroupCriteriaPayload>;
  addDraftGroupUser?: Maybe<AddDraftGroupUserPayload>;
  addGroupLeaders?: Maybe<AddGroupLeadersPayload>;
  addShifts?: Maybe<AddShiftsPayload>;
  addSupporterToGroup?: Maybe<AddSupporterToGroupPayload>;
  archiveCallingSession?: Maybe<ArchiveCallingSessionPayload>;
  archiveEvent?: Maybe<ArchiveEventPayload>;
  archiveGroup?: Maybe<ArchiveGroupPayload>;
  archiveShifts?: Maybe<ArchiveShiftsPayload>;
  assignShiftSlot?: Maybe<AssignShiftSlotPayload>;
  createDraftGroup?: Maybe<CreateDraftGroupPayload>;
  createGroup?: Maybe<CreateGroupPayload>;
  createSupporterNote?: Maybe<CreateSupporterNotePayload>;
  editShift?: Maybe<EditShiftPayload>;
  exportGroupSupporters?: Maybe<ExportGroupSupportersPayload>;
  exportRoster?: Maybe<ExportRosterPayload>;
  exportSupportersCsv?: Maybe<ExportSupportersCsvPayload>;
  initiateCall?: Maybe<InitiateCallPayload>;
  initiateCallingSession?: Maybe<InitiateCallingSessionPayload>;
  logContact?: Maybe<LogContactPayload>;
  prioritiseSupporter?: Maybe<PrioritiseSupporterPayload>;
  publishRoster?: Maybe<PublishRosterPayload>;
  removeDraftGroupUser?: Maybe<RemoveDraftGroupUserPayload>;
  removeGroupLeaders?: Maybe<RemoveGroupLeadersPayload>;
  removeGroupMembership?: Maybe<RemoveGroupMembershipPayload>;
  restoreRemovedAssignee?: Maybe<RestoreRemovedAssigneePayload>;
  revertShiftChanges?: Maybe<RevertShiftChangesPayload>;
  sendEmail?: Maybe<SendEmailPayload>;
  sendSms?: Maybe<SendSmsPayload>;
  skipSupporter?: Maybe<SkipSupporterPayload>;
  unassignShiftSlot?: Maybe<UnassignShiftSlotPayload>;
  undoShiftRemoval?: Maybe<UndoShiftRemovalPayload>;
  unskipSupporter?: Maybe<UnskipSupporterPayload>;
  updateDraftGroup?: Maybe<UpdateDraftGroupPayload>;
  updateGroup?: Maybe<UpdateGroupPayload>;
  updateGroupCriteria?: Maybe<UpdateGroupCriteriaPayload>;
  updateGroupPublicDescription?: Maybe<UpdateGroupPublicDescriptionPayload>;
  /** Update a supporter's details */
  updateSupporter?: Maybe<UpdateSupporterPayload>;
  updateSupporterEngagementLevel?: Maybe<UpdateSupporterEngagementLevelPayload>;
  updateSupporterTagFilters?: Maybe<UpdateSupporterTagFiltersPayload>;
  updateSupporterTags?: Maybe<UpdateSupporterTagsPayload>;
};


export type MutationAddDraftGroupCriteriaArgs = {
  input: AddDraftGroupCriteriaInput;
};


export type MutationAddDraftGroupUserArgs = {
  input: AddDraftGroupUserInput;
};


export type MutationAddGroupLeadersArgs = {
  input: AddGroupLeadersInput;
};


export type MutationAddShiftsArgs = {
  input: AddShiftsInput;
};


export type MutationAddSupporterToGroupArgs = {
  input: AddSupporterToGroupInput;
};


export type MutationArchiveCallingSessionArgs = {
  input: ArchiveCallingSessionInput;
};


export type MutationArchiveEventArgs = {
  input: ArchiveEventInput;
};


export type MutationArchiveGroupArgs = {
  input: ArchiveGroupInput;
};


export type MutationArchiveShiftsArgs = {
  input: ArchiveShiftsInput;
};


export type MutationAssignShiftSlotArgs = {
  input: AssignShiftSlotInput;
};


export type MutationCreateDraftGroupArgs = {
  input: CreateDraftGroupInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateSupporterNoteArgs = {
  input: CreateSupporterNoteInput;
};


export type MutationEditShiftArgs = {
  input: EditShiftInput;
};


export type MutationExportGroupSupportersArgs = {
  input: ExportGroupSupportersInput;
};


export type MutationExportRosterArgs = {
  input: ExportRosterInput;
};


export type MutationExportSupportersCsvArgs = {
  input: ExportSupportersCsvInput;
};


export type MutationInitiateCallArgs = {
  input: InitiateCallInput;
};


export type MutationInitiateCallingSessionArgs = {
  input: InitiateCallingSessionInput;
};


export type MutationLogContactArgs = {
  input: LogContactInput;
};


export type MutationPrioritiseSupporterArgs = {
  input: PrioritiseSupporterInput;
};


export type MutationPublishRosterArgs = {
  input: PublishRosterInput;
};


export type MutationRemoveDraftGroupUserArgs = {
  input: RemoveDraftGroupUserInput;
};


export type MutationRemoveGroupLeadersArgs = {
  input: RemoveGroupLeadersInput;
};


export type MutationRemoveGroupMembershipArgs = {
  input: RemoveGroupMembershipInput;
};


export type MutationRestoreRemovedAssigneeArgs = {
  input: RestoreRemovedAssigneeInput;
};


export type MutationRevertShiftChangesArgs = {
  input: RevertShiftChangesInput;
};


export type MutationSendEmailArgs = {
  input: SendEmailInput;
};


export type MutationSendSmsArgs = {
  input: SendSmsInput;
};


export type MutationSkipSupporterArgs = {
  input: SkipSupporterInput;
};


export type MutationUnassignShiftSlotArgs = {
  input: UnassignShiftSlotInput;
};


export type MutationUndoShiftRemovalArgs = {
  input: UndoShiftRemovalInput;
};


export type MutationUnskipSupporterArgs = {
  input: UnskipSupporterInput;
};


export type MutationUpdateDraftGroupArgs = {
  input: UpdateDraftGroupInput;
};


export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


export type MutationUpdateGroupCriteriaArgs = {
  input: UpdateGroupCriteriaInput;
};


export type MutationUpdateGroupPublicDescriptionArgs = {
  input: UpdateGroupPublicDescriptionInput;
};


export type MutationUpdateSupporterArgs = {
  input: UpdateSupporterInput;
};


export type MutationUpdateSupporterEngagementLevelArgs = {
  input: UpdateSupporterEngagementLevelInput;
};


export type MutationUpdateSupporterTagFiltersArgs = {
  input: UpdateSupporterTagFiltersInput;
};


export type MutationUpdateSupporterTagsArgs = {
  input: UpdateSupporterTagsInput;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PartEmail = {
  localPart: Scalars['String']['input'];
};

/** Autogenerated input type of PrioritiseSupporter */
export type PrioritiseSupporterInput = {
  callingSessionSupporterId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PrioritiseSupporter. */
export type PrioritiseSupporterPayload = {
  __typename?: 'PrioritiseSupporterPayload';
  callingSessionSupporter?: Maybe<CallingSessionSupporter>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** Progress bar data */
export type ProgressBar = {
  __typename?: 'ProgressBar';
  completedCount: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  totalSupportersCount: Scalars['Int']['output'];
};

/**
 * Why a volunteer is emailed by a publish. A volunteer caught by several changes
 * gets one email, of the most consequential kind.
 */
export enum PublishNotificationKind {
  /** Newly on a shift as of this publish. */
  Assigned = 'ASSIGNED',
  /** Already on a shift whose volunteer-visible details changed. */
  Changed = 'CHANGED',
  /** Taken off a shift, or on a shift being cancelled. */
  Unassigned = 'UNASSIGNED'
}

/** What publishing a roster would do right now, computed by the same code that does it. */
export type PublishPreview = {
  __typename?: 'PublishPreview';
  /** Spots volunteers can claim themselves once this publish lands. */
  claimableSpotCount: Scalars['Int']['output'];
  /** Of those, how many are already live and carry edits. */
  editedShiftCount: Scalars['Int']['output'];
  /** Of those, how many go live for the first time. */
  newShiftCount: Scalars['Int']['output'];
  /** Every volunteer this publish emails. One entry per person, however many shifts concern them. */
  recipients: Array<PublishRecipient>;
  /** Of those, how many are being cancelled. */
  removedShiftCount: Scalars['Int']['output'];
  /** How many shifts would be published. */
  shiftCount: Scalars['Int']['output'];
  /** The shifts that would be published. */
  shiftIds: Array<Scalars['ID']['output']>;
  /** Arriving staff-only shifts still short of volunteers. */
  understaffedShiftCount: Scalars['Int']['output'];
  /** Spots left open across those shifts. */
  unfilledSpotCount: Scalars['Int']['output'];
};

/** A volunteer who will be emailed by a publish, and why. */
export type PublishRecipient = {
  __typename?: 'PublishRecipient';
  /** Their name, as shown to the coordinator confirming the publish. */
  fullName?: Maybe<Scalars['String']['output']>;
  /** Which email they receive. */
  kind: PublishNotificationKind;
  /** The volunteer being emailed. */
  personId: Scalars['ID']['output'];
};

/** Autogenerated input type of PublishRoster */
export type PublishRosterInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  shiftIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of PublishRoster. */
export type PublishRosterPayload = {
  __typename?: 'PublishRosterPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  roster?: Maybe<Roster>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Query call lists for a group */
  callLists: Array<CallList>;
  /** Find CallingSession. */
  callingSession?: Maybe<CallingSession>;
  /** Find CallingSessionSupporter. */
  callingSessionSupporter?: Maybe<CallingSessionSupporter>;
  /** Query CallingSessionSupporters with filters. */
  callingSessionSupporters: CallingSessionSupporterConnection;
  /** Query CallingSessions with filters. */
  callingSessions: CallingSessionConnection;
  /** Find Contact. */
  contact?: Maybe<Contact>;
  /** Query Contacts with filters. */
  contacts: ContactConnection;
  /** Find DraftGroup. */
  draftGroup?: Maybe<DraftGroup>;
  /** Query DraftGroups with filters. */
  draftGroups: DraftGroupConnection;
  /** Query for a collection of email blasts */
  emailBlasts: EmailBlastConnection;
  /** Query engagement levels */
  engagementLevels?: Maybe<EngagementLevelConnection>;
  /** Find a single event */
  event: Event;
  /** All dates for a given event schedule */
  eventScheduleDates?: Maybe<Array<Scalars['String']['output']>>;
  /** Query for a collection of events */
  events?: Maybe<EventConnection>;
  /** Query events to list in dropdown field in log contact and RSVP form */
  eventsForRsvp?: Maybe<EventConnection>;
  /** Query federal districts */
  federalDistricts: FederalDistrictConnection;
  /** Find Group. */
  group?: Maybe<Group>;
  /** Find GroupMembership. */
  groupMembership?: Maybe<GroupMembership>;
  /** Query GroupMemberships with filters. */
  groupMemberships: GroupMembershipConnection;
  /** Query Groups with filters. */
  groups: GroupConnection;
  /** Query supporters based on user permissions */
  permittedSupporters?: Maybe<SupporterConnection>;
  /** Find Role. */
  role?: Maybe<Role>;
  /** Query Roles with filters. */
  roles: RoleConnection;
  /** Query for a collection of SMS blasts */
  smsBlasts: SmsBlastConnection;
  /** Search supporters for autocomplete when adding to a group */
  supporterAutocompleteSearch: Array<SupporterAutocompleteSearch>;
  /** Find SupporterNote. */
  supporterNote?: Maybe<SupporterNote>;
  /** Query SupporterNotes with filters. */
  supporterNotes: SupporterNoteConnection;
  supportersForCriteria?: Maybe<SupporterConnection>;
  /** Find Tag. */
  tag?: Maybe<Tag>;
  /** Query tag filters */
  tagFilters?: Maybe<TagFilterConnection>;
  /** Query Tags with filters. */
  tags: TagConnection;
  /** Find User. */
  user?: Maybe<User>;
  /** Query Users with filters. */
  users: UserConnection;
};


export type QueryCallListsArgs = {
  groupId: Scalars['ID']['input'];
};


export type QueryCallingSessionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCallingSessionSupporterArgs = {
  archivedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  callingSessionId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  supporterId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCallingSessionSupportersArgs = {
  actionGroupIdEq?: InputMaybe<Scalars['ID']['input']>;
  actionGroupIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  actionGroupIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  actionGroupIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  actionGroupIdNotNull?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  archivedAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  archivedAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  archivedAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  archivedAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  archivedAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  callingSessionIdEq?: InputMaybe<Scalars['ID']['input']>;
  callingSessionIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  callingSessionIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  callingSessionIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  callingSessionIdNotNull?: InputMaybe<Scalars['ID']['input']>;
  completedEq?: InputMaybe<Scalars['Boolean']['input']>;
  completedNotEq?: InputMaybe<Scalars['Boolean']['input']>;
  createdAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastCallAttemptAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  lastCallAttemptAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  lastCallAttemptAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  lastCallAttemptAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  lastCallAttemptAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  lastCallAttemptAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  outcomeEnd?: InputMaybe<Scalars['String']['input']>;
  outcomeEq?: InputMaybe<Scalars['String']['input']>;
  outcomeICont?: InputMaybe<Scalars['String']['input']>;
  outcomeIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  outcomeIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  outcomeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  outcomeNotEq?: InputMaybe<Scalars['String']['input']>;
  outcomeNotICont?: InputMaybe<Scalars['String']['input']>;
  outcomeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  outcomeStart?: InputMaybe<Scalars['String']['input']>;
  positionEq?: InputMaybe<Scalars['Int']['input']>;
  positionGt?: InputMaybe<Scalars['Int']['input']>;
  positionGteq?: InputMaybe<Scalars['Int']['input']>;
  positionLt?: InputMaybe<Scalars['Int']['input']>;
  positionLteq?: InputMaybe<Scalars['Int']['input']>;
  positionNotEq?: InputMaybe<Scalars['Int']['input']>;
  positionNotNull?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  supporterIdEq?: InputMaybe<Scalars['ID']['input']>;
  supporterIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  supporterIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  supporterIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  supporterIdNotNull?: InputMaybe<Scalars['ID']['input']>;
  unavailableReasonEnd?: InputMaybe<Scalars['String']['input']>;
  unavailableReasonEq?: InputMaybe<Scalars['String']['input']>;
  unavailableReasonICont?: InputMaybe<Scalars['String']['input']>;
  unavailableReasonIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  unavailableReasonIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  unavailableReasonIn?: InputMaybe<Array<Scalars['String']['input']>>;
  unavailableReasonNotEq?: InputMaybe<Scalars['String']['input']>;
  unavailableReasonNotICont?: InputMaybe<Scalars['String']['input']>;
  unavailableReasonNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  unavailableReasonStart?: InputMaybe<Scalars['String']['input']>;
  unavailableUntilEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  unavailableUntilGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  unavailableUntilGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  unavailableUntilLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  unavailableUntilLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  unavailableUntilNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type QueryCallingSessionsArgs = {
  actionGroupIdEq?: InputMaybe<Scalars['ID']['input']>;
  actionGroupIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  actionGroupIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  actionGroupIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  actionGroupIdNotNull?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  archivedAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  archivedAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  archivedAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  archivedAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  archivedAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  callInProgressAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  callInProgressAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  callInProgressAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  callInProgressAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  callInProgressAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  callInProgressAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameEnd?: InputMaybe<Scalars['String']['input']>;
  nameEq?: InputMaybe<Scalars['String']['input']>;
  nameICont?: InputMaybe<Scalars['String']['input']>;
  nameIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNotEq?: InputMaybe<Scalars['String']['input']>;
  nameNotICont?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameStart?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  updatedAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  userIdEq?: InputMaybe<Scalars['ID']['input']>;
  userIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  userIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIdNotNull?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContactArgs = {
  actionGroupId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
};


export type QueryContactsArgs = {
  actionGroupIdEq?: InputMaybe<Scalars['ID']['input']>;
  actionGroupIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  actionGroupIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  actionGroupIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  actionGroupIdNotNull?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  externalCreatedAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  externalCreatedAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  externalCreatedAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  externalCreatedAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  externalCreatedAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  externalCreatedAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  methodEnd?: InputMaybe<Scalars['String']['input']>;
  methodEq?: InputMaybe<Scalars['String']['input']>;
  methodICont?: InputMaybe<Scalars['String']['input']>;
  methodIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  methodIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  methodIn?: InputMaybe<Array<Scalars['String']['input']>>;
  methodNotEq?: InputMaybe<Scalars['String']['input']>;
  methodNotICont?: InputMaybe<Scalars['String']['input']>;
  methodNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  methodStart?: InputMaybe<Scalars['String']['input']>;
  noteEnd?: InputMaybe<Scalars['String']['input']>;
  noteEq?: InputMaybe<Scalars['String']['input']>;
  noteICont?: InputMaybe<Scalars['String']['input']>;
  noteIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  noteIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  noteIn?: InputMaybe<Array<Scalars['String']['input']>>;
  noteNotEq?: InputMaybe<Scalars['String']['input']>;
  noteNotICont?: InputMaybe<Scalars['String']['input']>;
  noteNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  noteStart?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  personIdEq?: InputMaybe<Scalars['ID']['input']>;
  personIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  personIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  personIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  personIdNotNull?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  statusEnd?: InputMaybe<Scalars['String']['input']>;
  statusEq?: InputMaybe<Scalars['String']['input']>;
  statusICont?: InputMaybe<Scalars['String']['input']>;
  statusIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  statusIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  statusIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statusNotEq?: InputMaybe<Scalars['String']['input']>;
  statusNotICont?: InputMaybe<Scalars['String']['input']>;
  statusNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statusStart?: InputMaybe<Scalars['String']['input']>;
  userIdEq?: InputMaybe<Scalars['ID']['input']>;
  userIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  userIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIdNotNull?: InputMaybe<Scalars['ID']['input']>;
  viaActionCentreEq?: InputMaybe<Scalars['Boolean']['input']>;
  viaActionCentreNotEq?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDraftGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDraftGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cityEnd?: InputMaybe<Scalars['String']['input']>;
  cityEq?: InputMaybe<Scalars['String']['input']>;
  cityICont?: InputMaybe<Scalars['String']['input']>;
  cityIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  cityIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  cityIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cityNotEq?: InputMaybe<Scalars['String']['input']>;
  cityNotICont?: InputMaybe<Scalars['String']['input']>;
  cityNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cityStart?: InputMaybe<Scalars['String']['input']>;
  countryEnd?: InputMaybe<Scalars['String']['input']>;
  countryEq?: InputMaybe<Scalars['String']['input']>;
  countryICont?: InputMaybe<Scalars['String']['input']>;
  countryIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  countryIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  countryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countryNotEq?: InputMaybe<Scalars['String']['input']>;
  countryNotICont?: InputMaybe<Scalars['String']['input']>;
  countryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countryStart?: InputMaybe<Scalars['String']['input']>;
  createdAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  descriptionEnd?: InputMaybe<Scalars['String']['input']>;
  descriptionEq?: InputMaybe<Scalars['String']['input']>;
  descriptionICont?: InputMaybe<Scalars['String']['input']>;
  descriptionIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotEq?: InputMaybe<Scalars['String']['input']>;
  descriptionNotICont?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionStart?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasPhysicalAddressEq?: InputMaybe<Scalars['Boolean']['input']>;
  hasPhysicalAddressNotEq?: InputMaybe<Scalars['Boolean']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  latitudeEq?: InputMaybe<Scalars['Float']['input']>;
  latitudeGt?: InputMaybe<Scalars['Float']['input']>;
  latitudeGteq?: InputMaybe<Scalars['Float']['input']>;
  latitudeLt?: InputMaybe<Scalars['Float']['input']>;
  latitudeLteq?: InputMaybe<Scalars['Float']['input']>;
  latitudeNotEq?: InputMaybe<Scalars['Float']['input']>;
  longitudeEq?: InputMaybe<Scalars['Float']['input']>;
  longitudeGt?: InputMaybe<Scalars['Float']['input']>;
  longitudeGteq?: InputMaybe<Scalars['Float']['input']>;
  longitudeLt?: InputMaybe<Scalars['Float']['input']>;
  longitudeLteq?: InputMaybe<Scalars['Float']['input']>;
  longitudeNotEq?: InputMaybe<Scalars['Float']['input']>;
  nameEnd?: InputMaybe<Scalars['String']['input']>;
  nameEq?: InputMaybe<Scalars['String']['input']>;
  nameICont?: InputMaybe<Scalars['String']['input']>;
  nameIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNotEq?: InputMaybe<Scalars['String']['input']>;
  nameNotICont?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameStart?: InputMaybe<Scalars['String']['input']>;
  notifyAllAdminsEq?: InputMaybe<Scalars['Boolean']['input']>;
  notifyAllAdminsNotEq?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  postcodeEnd?: InputMaybe<Scalars['String']['input']>;
  postcodeEq?: InputMaybe<Scalars['String']['input']>;
  postcodeICont?: InputMaybe<Scalars['String']['input']>;
  postcodeIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  postcodeIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  postcodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  postcodeNotEq?: InputMaybe<Scalars['String']['input']>;
  postcodeNotICont?: InputMaybe<Scalars['String']['input']>;
  postcodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  postcodeStart?: InputMaybe<Scalars['String']['input']>;
  publicDescriptionEnd?: InputMaybe<Scalars['String']['input']>;
  publicDescriptionEq?: InputMaybe<Scalars['String']['input']>;
  publicDescriptionICont?: InputMaybe<Scalars['String']['input']>;
  publicDescriptionIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  publicDescriptionIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  publicDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  publicDescriptionNotEq?: InputMaybe<Scalars['String']['input']>;
  publicDescriptionNotICont?: InputMaybe<Scalars['String']['input']>;
  publicDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  publicDescriptionStart?: InputMaybe<Scalars['String']['input']>;
  publicPublishEq?: InputMaybe<Scalars['Boolean']['input']>;
  publicPublishNotEq?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  stateEnd?: InputMaybe<Scalars['String']['input']>;
  stateEq?: InputMaybe<Scalars['String']['input']>;
  stateICont?: InputMaybe<Scalars['String']['input']>;
  stateIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  stateIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  stateIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateNotEq?: InputMaybe<Scalars['String']['input']>;
  stateNotICont?: InputMaybe<Scalars['String']['input']>;
  stateNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateStart?: InputMaybe<Scalars['String']['input']>;
  streetAddressEnd?: InputMaybe<Scalars['String']['input']>;
  streetAddressEq?: InputMaybe<Scalars['String']['input']>;
  streetAddressICont?: InputMaybe<Scalars['String']['input']>;
  streetAddressIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  streetAddressIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  streetAddressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  streetAddressNotEq?: InputMaybe<Scalars['String']['input']>;
  streetAddressNotICont?: InputMaybe<Scalars['String']['input']>;
  streetAddressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  streetAddressStart?: InputMaybe<Scalars['String']['input']>;
  updatedAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  venueNameEnd?: InputMaybe<Scalars['String']['input']>;
  venueNameEq?: InputMaybe<Scalars['String']['input']>;
  venueNameICont?: InputMaybe<Scalars['String']['input']>;
  venueNameIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  venueNameIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  venueNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  venueNameNotEq?: InputMaybe<Scalars['String']['input']>;
  venueNameNotICont?: InputMaybe<Scalars['String']['input']>;
  venueNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  venueNameStart?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmailBlastsArgs = {
  actionGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryEngagementLevelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventScheduleDatesArgs = {
  schedule: ScheduleInput;
  startDate: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
};


export type QueryEventsArgs = {
  actionGroupIdEq?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  rosteringEventsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  upcomingOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEventsForRsvpArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFederalDistrictsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameICont?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGroupMembershipArgs = {
  actionGroupId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
};


export type QueryGroupMembershipsArgs = {
  actionGroupIdEq?: InputMaybe<Scalars['ID']['input']>;
  actionGroupIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  actionGroupIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  actionGroupIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  actionGroupIdNotNull?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  personIdEq?: InputMaybe<Scalars['ID']['input']>;
  personIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  personIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  personIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  personIdNotNull?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cityEnd?: InputMaybe<Scalars['String']['input']>;
  cityEq?: InputMaybe<Scalars['String']['input']>;
  cityICont?: InputMaybe<Scalars['String']['input']>;
  cityIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  cityIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  cityIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cityNotEq?: InputMaybe<Scalars['String']['input']>;
  cityNotICont?: InputMaybe<Scalars['String']['input']>;
  cityNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cityStart?: InputMaybe<Scalars['String']['input']>;
  countryEnd?: InputMaybe<Scalars['String']['input']>;
  countryEq?: InputMaybe<Scalars['String']['input']>;
  countryICont?: InputMaybe<Scalars['String']['input']>;
  countryIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  countryIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  countryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countryNotEq?: InputMaybe<Scalars['String']['input']>;
  countryNotICont?: InputMaybe<Scalars['String']['input']>;
  countryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countryStart?: InputMaybe<Scalars['String']['input']>;
  createdAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  descriptionEnd?: InputMaybe<Scalars['String']['input']>;
  descriptionEq?: InputMaybe<Scalars['String']['input']>;
  descriptionICont?: InputMaybe<Scalars['String']['input']>;
  descriptionIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotEq?: InputMaybe<Scalars['String']['input']>;
  descriptionNotICont?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionStart?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasPhysicalAddressEq?: InputMaybe<Scalars['Boolean']['input']>;
  hasPhysicalAddressNotEq?: InputMaybe<Scalars['Boolean']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  latitudeEq?: InputMaybe<Scalars['Float']['input']>;
  latitudeGt?: InputMaybe<Scalars['Float']['input']>;
  latitudeGteq?: InputMaybe<Scalars['Float']['input']>;
  latitudeLt?: InputMaybe<Scalars['Float']['input']>;
  latitudeLteq?: InputMaybe<Scalars['Float']['input']>;
  latitudeNotEq?: InputMaybe<Scalars['Float']['input']>;
  longitudeEq?: InputMaybe<Scalars['Float']['input']>;
  longitudeGt?: InputMaybe<Scalars['Float']['input']>;
  longitudeGteq?: InputMaybe<Scalars['Float']['input']>;
  longitudeLt?: InputMaybe<Scalars['Float']['input']>;
  longitudeLteq?: InputMaybe<Scalars['Float']['input']>;
  longitudeNotEq?: InputMaybe<Scalars['Float']['input']>;
  mailerSenderEnd?: InputMaybe<Scalars['String']['input']>;
  mailerSenderEq?: InputMaybe<Scalars['String']['input']>;
  mailerSenderICont?: InputMaybe<Scalars['String']['input']>;
  mailerSenderIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  mailerSenderIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  mailerSenderIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mailerSenderNotEq?: InputMaybe<Scalars['String']['input']>;
  mailerSenderNotICont?: InputMaybe<Scalars['String']['input']>;
  mailerSenderNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mailerSenderStart?: InputMaybe<Scalars['String']['input']>;
  nameEnd?: InputMaybe<Scalars['String']['input']>;
  nameEq?: InputMaybe<Scalars['String']['input']>;
  nameICont?: InputMaybe<Scalars['String']['input']>;
  nameIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNotEq?: InputMaybe<Scalars['String']['input']>;
  nameNotICont?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameStart?: InputMaybe<Scalars['String']['input']>;
  notifyAllAdminsEq?: InputMaybe<Scalars['Boolean']['input']>;
  notifyAllAdminsNotEq?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  postcodeEnd?: InputMaybe<Scalars['String']['input']>;
  postcodeEq?: InputMaybe<Scalars['String']['input']>;
  postcodeICont?: InputMaybe<Scalars['String']['input']>;
  postcodeIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  postcodeIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  postcodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  postcodeNotEq?: InputMaybe<Scalars['String']['input']>;
  postcodeNotICont?: InputMaybe<Scalars['String']['input']>;
  postcodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  postcodeStart?: InputMaybe<Scalars['String']['input']>;
  publicDescriptionEnd?: InputMaybe<Scalars['String']['input']>;
  publicDescriptionEq?: InputMaybe<Scalars['String']['input']>;
  publicDescriptionICont?: InputMaybe<Scalars['String']['input']>;
  publicDescriptionIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  publicDescriptionIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  publicDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  publicDescriptionNotEq?: InputMaybe<Scalars['String']['input']>;
  publicDescriptionNotICont?: InputMaybe<Scalars['String']['input']>;
  publicDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  publicDescriptionStart?: InputMaybe<Scalars['String']['input']>;
  publicPublishEq?: InputMaybe<Scalars['Boolean']['input']>;
  publicPublishNotEq?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  stateEnd?: InputMaybe<Scalars['String']['input']>;
  stateEq?: InputMaybe<Scalars['String']['input']>;
  stateICont?: InputMaybe<Scalars['String']['input']>;
  stateIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  stateIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  stateIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateNotEq?: InputMaybe<Scalars['String']['input']>;
  stateNotICont?: InputMaybe<Scalars['String']['input']>;
  stateNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateStart?: InputMaybe<Scalars['String']['input']>;
  statusEnd?: InputMaybe<Scalars['String']['input']>;
  statusEq?: InputMaybe<Scalars['String']['input']>;
  statusICont?: InputMaybe<Scalars['String']['input']>;
  statusIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  statusIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  statusIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statusNotEq?: InputMaybe<Scalars['String']['input']>;
  statusNotICont?: InputMaybe<Scalars['String']['input']>;
  statusNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statusStart?: InputMaybe<Scalars['String']['input']>;
  streetAddressEnd?: InputMaybe<Scalars['String']['input']>;
  streetAddressEq?: InputMaybe<Scalars['String']['input']>;
  streetAddressICont?: InputMaybe<Scalars['String']['input']>;
  streetAddressIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  streetAddressIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  streetAddressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  streetAddressNotEq?: InputMaybe<Scalars['String']['input']>;
  streetAddressNotICont?: InputMaybe<Scalars['String']['input']>;
  streetAddressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  streetAddressStart?: InputMaybe<Scalars['String']['input']>;
  venueNameEnd?: InputMaybe<Scalars['String']['input']>;
  venueNameEq?: InputMaybe<Scalars['String']['input']>;
  venueNameICont?: InputMaybe<Scalars['String']['input']>;
  venueNameIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  venueNameIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  venueNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  venueNameNotEq?: InputMaybe<Scalars['String']['input']>;
  venueNameNotICont?: InputMaybe<Scalars['String']['input']>;
  venueNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  venueNameStart?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPermittedSupportersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fullNameICont?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameEnd?: InputMaybe<Scalars['String']['input']>;
  nameEq?: InputMaybe<Scalars['String']['input']>;
  nameICont?: InputMaybe<Scalars['String']['input']>;
  nameIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNotEq?: InputMaybe<Scalars['String']['input']>;
  nameNotICont?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameStart?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySmsBlastsArgs = {
  actionGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QuerySupporterAutocompleteSearchArgs = {
  groupId: Scalars['ID']['input'];
  term: Scalars['String']['input'];
};


export type QuerySupporterNoteArgs = {
  actionGroupId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
};


export type QuerySupporterNotesArgs = {
  actionGroupIdEq?: InputMaybe<Scalars['ID']['input']>;
  actionGroupIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  actionGroupIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  actionGroupIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  actionGroupIdNotNull?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorEnd?: InputMaybe<Scalars['String']['input']>;
  authorEq?: InputMaybe<Scalars['String']['input']>;
  authorICont?: InputMaybe<Scalars['String']['input']>;
  authorIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  authorIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  authorIn?: InputMaybe<Array<Scalars['String']['input']>>;
  authorNotEq?: InputMaybe<Scalars['String']['input']>;
  authorNotICont?: InputMaybe<Scalars['String']['input']>;
  authorNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  authorStart?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contentEnd?: InputMaybe<Scalars['String']['input']>;
  contentEq?: InputMaybe<Scalars['String']['input']>;
  contentICont?: InputMaybe<Scalars['String']['input']>;
  contentIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  contentIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  contentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  contentNotEq?: InputMaybe<Scalars['String']['input']>;
  contentNotICont?: InputMaybe<Scalars['String']['input']>;
  contentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  contentStart?: InputMaybe<Scalars['String']['input']>;
  createdAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  personIdEq?: InputMaybe<Scalars['ID']['input']>;
  personIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  personIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  personIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  personIdNotNull?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  updatedAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type QuerySupportersForCriteriaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  criteria: CriteriaInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTagArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTagFiltersArgs = {
  actionGroupIdEq: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameEnd?: InputMaybe<Scalars['String']['input']>;
  nameEq?: InputMaybe<Scalars['String']['input']>;
  nameICont?: InputMaybe<Scalars['String']['input']>;
  nameIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNotEq?: InputMaybe<Scalars['String']['input']>;
  nameNotICont?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameStart?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  emailEnd?: InputMaybe<Scalars['String']['input']>;
  emailEq?: InputMaybe<Scalars['String']['input']>;
  emailICont?: InputMaybe<Scalars['String']['input']>;
  emailIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  emailIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailNotEq?: InputMaybe<Scalars['String']['input']>;
  emailNotICont?: InputMaybe<Scalars['String']['input']>;
  emailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailStart?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  firstNameEnd?: InputMaybe<Scalars['String']['input']>;
  firstNameEq?: InputMaybe<Scalars['String']['input']>;
  firstNameICont?: InputMaybe<Scalars['String']['input']>;
  firstNameIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameNotEq?: InputMaybe<Scalars['String']['input']>;
  firstNameNotICont?: InputMaybe<Scalars['String']['input']>;
  firstNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameStart?: InputMaybe<Scalars['String']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastNameEnd?: InputMaybe<Scalars['String']['input']>;
  lastNameEq?: InputMaybe<Scalars['String']['input']>;
  lastNameICont?: InputMaybe<Scalars['String']['input']>;
  lastNameIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameNotEq?: InputMaybe<Scalars['String']['input']>;
  lastNameNotICont?: InputMaybe<Scalars['String']['input']>;
  lastNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameStart?: InputMaybe<Scalars['String']['input']>;
  mobileEnd?: InputMaybe<Scalars['String']['input']>;
  mobileEq?: InputMaybe<Scalars['String']['input']>;
  mobileICont?: InputMaybe<Scalars['String']['input']>;
  mobileIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileNotEq?: InputMaybe<Scalars['String']['input']>;
  mobileNotICont?: InputMaybe<Scalars['String']['input']>;
  mobileNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileStart?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of RemoveDraftGroupUser */
export type RemoveDraftGroupUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveDraftGroupUser. */
export type RemoveDraftGroupUserPayload = {
  __typename?: 'RemoveDraftGroupUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
  user?: Maybe<DraftUser>;
};

/** Autogenerated input type of RemoveGroupLeaders */
export type RemoveGroupLeadersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  users: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of RemoveGroupLeaders. */
export type RemoveGroupLeadersPayload = {
  __typename?: 'RemoveGroupLeadersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
  users?: Maybe<Array<User>>;
};

/** Autogenerated input type of RemoveGroupMembership */
export type RemoveGroupMembershipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['ID']['input'];
  supporterId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveGroupMembership. */
export type RemoveGroupMembershipPayload = {
  __typename?: 'RemoveGroupMembershipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  group?: Maybe<Group>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
  supporter?: Maybe<Supporter>;
};

/** Autogenerated input type of RestoreRemovedAssignee */
export type RestoreRemovedAssigneeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['ID']['input'];
  shiftId: Scalars['ID']['input'];
};

/** Autogenerated return type of RestoreRemovedAssignee. */
export type RestoreRemovedAssigneePayload = {
  __typename?: 'RestoreRemovedAssigneePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  shift?: Maybe<Shift>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RevertShiftChanges */
export type RevertShiftChangesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RevertShiftChanges. */
export type RevertShiftChangesPayload = {
  __typename?: 'RevertShiftChangesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  shift?: Maybe<Shift>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** A role in the application */
export type Role = {
  __typename?: 'Role';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Query related Users with filters. */
  users: UserConnection;
};


/** A role in the application */
export type RoleUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  emailEnd?: InputMaybe<Scalars['String']['input']>;
  emailEq?: InputMaybe<Scalars['String']['input']>;
  emailICont?: InputMaybe<Scalars['String']['input']>;
  emailIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  emailIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailNotEq?: InputMaybe<Scalars['String']['input']>;
  emailNotICont?: InputMaybe<Scalars['String']['input']>;
  emailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailStart?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  firstNameEnd?: InputMaybe<Scalars['String']['input']>;
  firstNameEq?: InputMaybe<Scalars['String']['input']>;
  firstNameICont?: InputMaybe<Scalars['String']['input']>;
  firstNameIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameNotEq?: InputMaybe<Scalars['String']['input']>;
  firstNameNotICont?: InputMaybe<Scalars['String']['input']>;
  firstNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameStart?: InputMaybe<Scalars['String']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastNameEnd?: InputMaybe<Scalars['String']['input']>;
  lastNameEq?: InputMaybe<Scalars['String']['input']>;
  lastNameICont?: InputMaybe<Scalars['String']['input']>;
  lastNameIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameNotEq?: InputMaybe<Scalars['String']['input']>;
  lastNameNotICont?: InputMaybe<Scalars['String']['input']>;
  lastNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameStart?: InputMaybe<Scalars['String']['input']>;
  mobileEnd?: InputMaybe<Scalars['String']['input']>;
  mobileEq?: InputMaybe<Scalars['String']['input']>;
  mobileICont?: InputMaybe<Scalars['String']['input']>;
  mobileIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileNotEq?: InputMaybe<Scalars['String']['input']>;
  mobileNotICont?: InputMaybe<Scalars['String']['input']>;
  mobileNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileStart?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for Role. */
export type RoleConnection = {
  __typename?: 'RoleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RoleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Role>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type RoleEdge = {
  __typename?: 'RoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Role>;
};

export type Roster = BaseNode & {
  __typename?: 'Roster';
  id: Scalars['ID']['output'];
  /** What publishing would do right now: which shifts go live, and exactly which volunteers get emailed. */
  publishPreview: PublishPreview;
  shifts?: Maybe<ShiftConnection>;
};


export type RosterPublishPreviewArgs = {
  shiftIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type RosterShiftsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  upcomingOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScheduleInput =
  { withCount: ScheduleWithCountInput; withDate?: never; }
  |  { withCount?: never; withDate: ScheduleWithDateInput; };

/** A schedule with an explicit event count */
export type ScheduleWithCountInput = {
  byWeekDay?: InputMaybe<Array<Scalars['String']['input']>>;
  count: Scalars['String']['input'];
  frequency: Scalars['String']['input'];
  interval?: InputMaybe<Scalars['String']['input']>;
  useEndsOn: Scalars['Boolean']['input'];
};

/** A schedule with an end date and dynamic event count */
export type ScheduleWithDateInput = {
  byWeekDay?: InputMaybe<Array<Scalars['String']['input']>>;
  endsOn: Scalars['String']['input'];
  frequency: Scalars['String']['input'];
  interval?: InputMaybe<Scalars['String']['input']>;
  useEndsOn: Scalars['Boolean']['input'];
};

/** Autogenerated input type of SendEmail */
export type SendEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emailBody: Scalars['String']['input'];
  emailSubject: Scalars['String']['input'];
  groupId: Scalars['ID']['input'];
  replyTo?: InputMaybe<Scalars['String']['input']>;
  senderName: Scalars['String']['input'];
  supporterId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendEmail. */
export type SendEmailPayload = {
  __typename?: 'SendEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendSms */
export type SendSmsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['ID']['input'];
  smsBody: Scalars['String']['input'];
  supporterId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendSms. */
export type SendSmsPayload = {
  __typename?: 'SendSmsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

export type Shift = BaseNode & {
  __typename?: 'Shift';
  allowSelfSelect: Scalars['Boolean']['output'];
  /** What has changed since last publish. Null when there is nothing to diff (a draft, or a net-zero change). */
  changeBreakdown?: Maybe<ShiftChangeBreakdown>;
  draft: Scalars['Boolean']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Whether the supporter occupies a slot on this shift */
  isAssignedToSupporter: Scalars['Boolean']['output'];
  /** Whether every slot is assigned */
  isFull: Scalars['Boolean']['output'];
  publishState: ShiftPublishState;
  /** Volunteers unassigned since last publish, carried from the snapshot for the removed row. */
  removedAssignees: Array<AssigneeRef>;
  roleName: Scalars['String']['output'];
  roster?: Maybe<Roster>;
  /** Query related ShiftSlots with filters. */
  shiftSlots: ShiftSlotsConnection;
  startTime: Scalars['String']['output'];
};


export type ShiftIsAssignedToSupporterArgs = {
  supporterId: Scalars['ID']['input'];
};


export type ShiftShiftSlotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  shiftIdEq?: InputMaybe<Scalars['ID']['input']>;
  shiftIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  shiftIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  shiftIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  shiftIdNotNull?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

/** What has changed on a published shift since it was last published. */
export type ShiftChangeBreakdown = {
  __typename?: 'ShiftChangeBreakdown';
  addedAssignees: Array<AssigneeRef>;
  fieldChanges: Array<FieldChange>;
  removedAssignees: Array<AssigneeRef>;
};

/** The connection type for Shift. */
export type ShiftConnection = {
  __typename?: 'ShiftConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ShiftEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Shift>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type ShiftEdge = {
  __typename?: 'ShiftEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Shift>;
};

export type ShiftInput = {
  allowSelfSelect?: InputMaybe<Scalars['Boolean']['input']>;
  draft: Scalars['Boolean']['input'];
  endTime: Scalars['ISO8601DateTime']['input'];
  roleName: Scalars['String']['input'];
  startTime: Scalars['ISO8601DateTime']['input'];
  volunteersRequired: Scalars['Int']['input'];
};

/** A computed shift's publish state, not stored in the database. Controls how the shift appears on the roster board. */
export enum ShiftPublishState {
  /** Removed for good, or a deleted draft. Hidden from everyone. */
  Archived = 'ARCHIVED',
  /** Never published. Shows on the board for organisers, but not to volunteers. */
  Draft = 'DRAFT',
  /** Marked for removal. Still live to volunteers, and reversible until the next publish. */
  PendingRemoval = 'PENDING_REMOVAL',
  /** Published and live to volunteers. */
  Published = 'PUBLISHED',
  /** Published, then edited. The edits are not live until the next publish. */
  UnpublishedChanges = 'UNPUBLISHED_CHANGES'
}

export type ShiftSlot = {
  __typename?: 'ShiftSlot';
  id: Scalars['ID']['output'];
  /** Whether this slot's assignee was live at the last publish. False for an added-but-unpublished assignee or an empty slot. */
  published: Scalars['Boolean']['output'];
  shift?: Maybe<Shift>;
  supporter?: Maybe<Supporter>;
  supporterShift?: Maybe<SupporterShift>;
};

/** An edge in a connection. */
export type ShiftSlotEdge = {
  __typename?: 'ShiftSlotEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ShiftSlot>;
};

/** The connection type for ShiftSlot. */
export type ShiftSlotsConnection = {
  __typename?: 'ShiftSlotsConnection';
  assignedCount: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ShiftSlotEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ShiftSlot>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of SkipSupporter */
export type SkipSupporterInput = {
  callingSessionSupporterId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  skipType: CallingSessionSkipTypeEnum;
};

/** Autogenerated return type of SkipSupporter. */
export type SkipSupporterPayload = {
  __typename?: 'SkipSupporterPayload';
  callingSessionSupporter?: Maybe<CallingSessionSupporter>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** An SMS blast */
export type SmsBlast = BaseNode & {
  __typename?: 'SmsBlast';
  actionGroup?: Maybe<Group>;
  audience: BlastAudience;
  /** Used to derive per-row permissions on the client */
  authorId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  recipientCount: Scalars['Int']['output'];
  /** When an upcoming send goes out. Null unless the blast is scheduled or approved. */
  scheduledFor?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the blast actually went out. Null unless it is sent. */
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: Scalars['String']['output'];
  /** The email's subject, or the SMS's message */
  title?: Maybe<Scalars['String']['output']>;
};

/** The connection type for SmsBlast. */
export type SmsBlastConnection = {
  __typename?: 'SmsBlastConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SmsBlastEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SmsBlast>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type SmsBlastEdge = {
  __typename?: 'SmsBlastEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SmsBlast>;
};

/** Whether an SMS was sent from SupporterBase or received from the supporter */
export enum SmsDirection {
  /** A reply received from the supporter */
  Inbound = 'INBOUND',
  /** Sent from SupporterBase by a leader */
  Outbound = 'OUTBOUND'
}

/** Which source an SMS in a supporter conversation came from */
export enum SmsMessageKind {
  /** A bulk SMS blast the supporter received */
  Blast = 'BLAST',
  /** A 1:1 message sent to the supporter by a leader */
  Individual = 'INDIVIDUAL',
  /** A reply received from the supporter */
  Reply = 'REPLY'
}

/** An SMS thread */
export type SmsThread = BaseNode & {
  __typename?: 'SmsThread';
  id: Scalars['ID']['output'];
  isResponded: Scalars['Boolean']['output'];
  personId?: Maybe<Scalars['ID']['output']>;
};

/** The connection type for SmsThread. */
export type SmsThreadConnection = {
  __typename?: 'SmsThreadConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SmsThreadEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SmsThread>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type SmsThreadEdge = {
  __typename?: 'SmsThreadEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SmsThread>;
};

/** A supporter of a group */
export type Supporter = {
  __typename?: 'Supporter';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  birthdate?: Maybe<Scalars['ISO8601Date']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  engagementLevel?: Maybe<Scalars['String']['output']>;
  externalCreatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  federalDistrict?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastContactedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  primaryMobile?: Maybe<Scalars['String']['output']>;
  primaryPhone?: Maybe<Scalars['String']['output']>;
  rsvpCount: Scalars['Int']['output'];
  /** The supporter's merged SMS conversation, newest first */
  smsMessages: SupporterSmsMessageConnection;
  state?: Maybe<Scalars['String']['output']>;
  /** Query related SupporterNotes with filters. */
  supporterNotes: SupporterNoteConnection;
  /** Query related Tags with filters. */
  tags: TagConnection;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};


/** A supporter of a group */
export type SupporterSmsMessagesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A supporter of a group */
export type SupporterSupporterNotesArgs = {
  actionGroupIdEq?: InputMaybe<Scalars['ID']['input']>;
  actionGroupIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  actionGroupIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  actionGroupIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  actionGroupIdNotNull?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorEnd?: InputMaybe<Scalars['String']['input']>;
  authorEq?: InputMaybe<Scalars['String']['input']>;
  authorICont?: InputMaybe<Scalars['String']['input']>;
  authorIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  authorIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  authorIn?: InputMaybe<Array<Scalars['String']['input']>>;
  authorNotEq?: InputMaybe<Scalars['String']['input']>;
  authorNotICont?: InputMaybe<Scalars['String']['input']>;
  authorNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  authorStart?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contentEnd?: InputMaybe<Scalars['String']['input']>;
  contentEq?: InputMaybe<Scalars['String']['input']>;
  contentICont?: InputMaybe<Scalars['String']['input']>;
  contentIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  contentIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  contentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  contentNotEq?: InputMaybe<Scalars['String']['input']>;
  contentNotICont?: InputMaybe<Scalars['String']['input']>;
  contentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  contentStart?: InputMaybe<Scalars['String']['input']>;
  createdAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  personIdEq?: InputMaybe<Scalars['ID']['input']>;
  personIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  personIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  personIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  personIdNotNull?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  updatedAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtNotEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


/** A supporter of a group */
export type SupporterTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameEnd?: InputMaybe<Scalars['String']['input']>;
  nameEq?: InputMaybe<Scalars['String']['input']>;
  nameICont?: InputMaybe<Scalars['String']['input']>;
  nameIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNotEq?: InputMaybe<Scalars['String']['input']>;
  nameNotICont?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameStart?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

/** A supporter result from autocomplete search */
export type SupporterAutocompleteSearch = {
  __typename?: 'SupporterAutocompleteSearch';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  memberOfGroup: Scalars['Boolean']['output'];
};

/** The connection type for Supporter. */
export type SupporterConnection = {
  __typename?: 'SupporterConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SupporterEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Supporter>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type SupporterEdge = {
  __typename?: 'SupporterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Supporter>;
};

/** A note with comments about a supporter */
export type SupporterNote = BaseNode & {
  __typename?: 'SupporterNote';
  actionGroupId?: Maybe<Scalars['ID']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  personId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for SupporterNote. */
export type SupporterNoteConnection = {
  __typename?: 'SupporterNoteConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SupporterNoteEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SupporterNote>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type SupporterNoteEdge = {
  __typename?: 'SupporterNoteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SupporterNote>;
};

/** A search interface to apply multiple filters */
export type SupporterSearchFiltersInputType = {
  actionGroupMembersCreatedAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  actionGroupMembersCreatedAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  actionGroupMembersCreatedAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  callableFalse?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  callableTrue?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  cityBlank?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  cityIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cityNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cityPresent?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  countryCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countryCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countyDistrictIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countyDistrictNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  emailBlank?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  emailPresent?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  emailableFalse?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  emailableTrue?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  engagementLevelBlank?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  engagementLevelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  engagementLevelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  engagementLevelPresent?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  eventRsvpsBlank?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  eventRsvpsHasAll?: InputMaybe<Array<Scalars['String']['input']>>;
  eventRsvpsHasAny?: InputMaybe<Array<Scalars['String']['input']>>;
  eventRsvpsNotAny?: InputMaybe<Array<Scalars['String']['input']>>;
  eventRsvpsPresent?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  externalCreatedAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  externalCreatedAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  externalCreatedAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  federalDistrictBlank?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  federalDistrictIn?: InputMaybe<Array<Scalars['String']['input']>>;
  federalDistrictNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  federalDistrictPresent?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  firstNameICont?: InputMaybe<Scalars['String']['input']>;
  firstNameNotICont?: InputMaybe<Scalars['String']['input']>;
  firstNameStart?: InputMaybe<Scalars['String']['input']>;
  fullNameICont?: InputMaybe<Scalars['String']['input']>;
  lastContactedAtEq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  lastContactedAtGt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  lastContactedAtLt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  lastContactedAtNull?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  lastNameICont?: InputMaybe<Scalars['String']['input']>;
  lastNameNotICont?: InputMaybe<Scalars['String']['input']>;
  lastNameStart?: InputMaybe<Scalars['String']['input']>;
  noteBlank?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  noteICont?: InputMaybe<Scalars['String']['input']>;
  noteNotICont?: InputMaybe<Scalars['String']['input']>;
  notePresent?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  primaryMobileBlank?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  primaryMobilePresent?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  primaryPhoneBlank?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  primaryPhonePresent?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  schoolDistrictIn?: InputMaybe<Array<Scalars['String']['input']>>;
  schoolDistrictNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateBlank?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  stateIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateLowerDistrictIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateLowerDistrictNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statePresent?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  supporterNotesICont?: InputMaybe<Scalars['String']['input']>;
  supporterNotesNotICont?: InputMaybe<Scalars['String']['input']>;
  supranationalDistrictIn?: InputMaybe<Array<Scalars['String']['input']>>;
  supranationalDistrictNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsHasAll?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsHasAny?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsNotAny?: InputMaybe<Array<Scalars['String']['input']>>;
  textableFalse?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  textableTrue?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  zipBlank?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  zipIn?: InputMaybe<Array<Scalars['String']['input']>>;
  zipNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  zipPresent?: InputMaybe<Scalars['BooleanWithStrings']['input']>;
  zipStart?: InputMaybe<Scalars['String']['input']>;
};

export type SupporterShift = {
  __typename?: 'SupporterShift';
  id: Scalars['ID']['output'];
  shiftSlot?: Maybe<ShiftSlot>;
  supporter?: Maybe<Supporter>;
};

/** A single SMS in a supporter conversation (outbound or inbound) */
export type SupporterSmsMessage = {
  __typename?: 'SupporterSmsMessage';
  /** Path to the SMS blast detail page; only present for bulk blast messages */
  blastPath?: Maybe<Scalars['String']['output']>;
  body: Scalars['String']['output'];
  direction: SmsDirection;
  /** Event a blast was sent to when it targeted RSVPs; null otherwise */
  eventName?: Maybe<Scalars['String']['output']>;
  /** Group an outbound message was sent from; null for inbound replies */
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Which source the message came from (1:1, blast, or reply) */
  kind: SmsMessageKind;
  /** Leader who sent an outbound message; null for inbound replies */
  senderName?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['ISO8601DateTime']['output'];
};

/** A page of a supporter's SMS conversation, newest first */
export type SupporterSmsMessageConnection = {
  __typename?: 'SupporterSmsMessageConnection';
  nodes: Array<SupporterSmsMessage>;
  /** Total number of messages across the whole conversation */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** Tags */
export type Tag = BaseNode & {
  __typename?: 'Tag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** The connection type for Tag. */
export type TagConnection = {
  __typename?: 'TagConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TagEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Tag>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type TagEdge = {
  __typename?: 'TagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Tag>;
};

/** A tag filter */
export type TagFilter = {
  __typename?: 'TagFilter';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** The connection type for TagFilter. */
export type TagFilterConnection = {
  __typename?: 'TagFilterConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TagFilterEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TagFilter>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type TagFilterEdge = {
  __typename?: 'TagFilterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TagFilter>;
};

/** Autogenerated input type of UnassignShiftSlot */
export type UnassignShiftSlotInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UnassignShiftSlot. */
export type UnassignShiftSlotPayload = {
  __typename?: 'UnassignShiftSlotPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  shiftSlot?: Maybe<ShiftSlot>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UndoShiftRemoval */
export type UndoShiftRemovalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UndoShiftRemoval. */
export type UndoShiftRemovalPayload = {
  __typename?: 'UndoShiftRemovalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  shift?: Maybe<Shift>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UnskipSupporter */
export type UnskipSupporterInput = {
  callingSessionSupporterId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UnskipSupporter. */
export type UnskipSupporterPayload = {
  __typename?: 'UnskipSupporterPayload';
  callingSessionSupporter?: Maybe<CallingSessionSupporter>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** An unsubscriber record for a person on a group */
export type Unsubscriber = {
  __typename?: 'Unsubscriber';
  actionGroupId: Scalars['ID']['output'];
  completelyUnsubscribed: Scalars['Boolean']['output'];
  personId: Scalars['ID']['output'];
  stopReceivingCalls: Scalars['Boolean']['output'];
  stopReceivingEmails: Scalars['Boolean']['output'];
  stopReceivingSms: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateDraftGroup */
export type UpdateDraftGroupInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasPhysicalAddress?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notifyAllAdmins?: InputMaybe<Scalars['Boolean']['input']>;
  pointPeople?: InputMaybe<Array<Scalars['ID']['input']>>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  publicPublish?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  venueName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateDraftGroup. */
export type UpdateDraftGroupPayload = {
  __typename?: 'UpdateDraftGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  draftGroup?: Maybe<DraftGroup>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateGroupCriteria */
export type UpdateGroupCriteriaInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  combinator?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  rules?: InputMaybe<CriteriaRulesInput>;
};

/** Autogenerated return type of UpdateGroupCriteria. */
export type UpdateGroupCriteriaPayload = {
  __typename?: 'UpdateGroupCriteriaPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  groupCriteria?: Maybe<GroupCriteria>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateGroup */
export type UpdateGroupInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasPhysicalAddress?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  mailerSender?: InputMaybe<PartEmail>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifyAllAdmins?: InputMaybe<Scalars['Boolean']['input']>;
  pointPeople?: InputMaybe<Array<Scalars['ID']['input']>>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  publicPublish?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  venueName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateGroup. */
export type UpdateGroupPayload = {
  __typename?: 'UpdateGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  group?: Maybe<Group>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateGroupPublicDescription */
export type UpdateGroupPublicDescriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  publicDescription?: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateGroupPublicDescription. */
export type UpdateGroupPublicDescriptionPayload = {
  __typename?: 'UpdateGroupPublicDescriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  group?: Maybe<Group>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateSupporterEngagementLevel */
export type UpdateSupporterEngagementLevelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementLevelId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateSupporterEngagementLevel. */
export type UpdateSupporterEngagementLevelPayload = {
  __typename?: 'UpdateSupporterEngagementLevelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
  supporter?: Maybe<Supporter>;
};

/** Autogenerated input type of UpdateSupporter */
export type UpdateSupporterInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  federalDistrict?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the supporter to update */
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateSupporter. */
export type UpdateSupporterPayload = {
  __typename?: 'UpdateSupporterPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
  supporter?: Maybe<Supporter>;
};

/** Autogenerated input type of UpdateSupporterTagFilters */
export type UpdateSupporterTagFiltersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  tagFilterIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateSupporterTagFilters. */
export type UpdateSupporterTagFiltersPayload = {
  __typename?: 'UpdateSupporterTagFiltersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
  supporter?: Maybe<Supporter>;
};

/** Autogenerated input type of UpdateSupporterTags */
export type UpdateSupporterTagsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateSupporterTags. */
export type UpdateSupporterTagsPayload = {
  __typename?: 'UpdateSupporterTagsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors (if any) that occurred during the mutation */
  errors: Array<UserError>;
  /** A translated success response to optionally display to the user */
  message?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the mutation was performed */
  success: Scalars['Boolean']['output'];
  supporter?: Maybe<Supporter>;
};

/** A user of the application */
export type User = BaseNode & {
  __typename?: 'User';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  /** Query related UserRoles with filters. */
  userRoles: UserRoleConnection;
};


/** A user of the application */
export type UserUserRolesArgs = {
  actionGroupIdEq?: InputMaybe<Scalars['ID']['input']>;
  actionGroupIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  actionGroupIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  actionGroupIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  actionGroupIdNotNull?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  idEq?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotEq?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNotNull?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  roleIdEq?: InputMaybe<Scalars['ID']['input']>;
  roleIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  roleIdNotEq?: InputMaybe<Scalars['ID']['input']>;
  roleIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  roleIdNotNull?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

/** An error object that describes a user error */
export type UserError = {
  __typename?: 'UserError';
  /** A code for the error */
  code: Scalars['String']['output'];
  /** The field the error occurred on */
  field?: Maybe<Scalars['String']['output']>;
  /** A description of the error */
  message: Scalars['String']['output'];
  /** A possible solution for the error */
  solution?: Maybe<Scalars['String']['output']>;
};

/** A user's role in a specific group */
export type UserRole = BaseNode & {
  __typename?: 'UserRole';
  actionGroupId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** Find child Role. */
  role: Role;
};

/** The connection type for UserRole. */
export type UserRoleConnection = {
  __typename?: 'UserRoleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserRoleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UserRole>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Number of items per page (the first/last argument) */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Total number of items in the connection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the page size */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type UserRoleEdge = {
  __typename?: 'UserRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserRole>;
};
